var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskProfiler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 180,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 284,
    height: 190,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -14)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h244a8 8 0 0 1 8 8v158H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h244a7.5 7.5 0 0 1 7.5 7.5v157.5h-259V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h244a8 8 0 0 1 8 8v16H0V8a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .5h244a7.5 7.5 0 0 1 7.5 7.5v15.5H.5V8A7.5 7.5 0 0 1 8 .5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(10 9.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 -.21)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8 -.21)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16 -.21)",
    fill: "#00c243"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 23h222v143H19z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.5 23.5h221v142h-221z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1222",
    transform: "translate(-432.365 -921)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 99,
    height: 16,
    rx: 3,
    transform: "translate(513.365 1060)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Show Retirement funds",
    transform: "translate(517.365 1071)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Show Retirement funds"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Medium Risk",
    transform: "translate(76 71)",
    fill: "#454545",
    fontSize: 9,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Medium Risk")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M80.15 100a16.146 16.146 0 0 1 13.983 8.073 16.146 16.146 0 0 1 0 16.146l-2.817-1.626a12.894 12.894 0 0 0 0-12.894 12.894 12.894 0 0 0-11.166-6.446Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M94.133 124.219a16.146 16.146 0 0 1-20.989 6.474l1.411-2.93a12.894 12.894 0 0 0 16.761-5.17Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M73.144 130.694a16.146 16.146 0 0 1-8.025-20.446l3.028 1.188a12.894 12.894 0 0 0 6.409 16.328Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M65.115 110.247A16.146 16.146 0 0 1 80.15 100v3.253a12.894 12.894 0 0 0-12 8.183Z",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 44,
    height: 4,
    rx: 1,
    transform: "translate(76 56)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 29,
    height: 29,
    rx: 4,
    transform: "translate(41 50)",
    fill: "#9098a4",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1511",
    width: 29,
    height: 29,
    rx: 4,
    transform: "translate(193 50)",
    fill: "#ffc1c8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1507",
    width: 14,
    height: 4,
    rx: 1,
    transform: "translate(108 110)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1518",
    width: 14,
    height: 4,
    rx: 1,
    transform: "translate(133.704 110)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1520",
    width: 14,
    height: 4,
    rx: 1,
    transform: "translate(159.408 110)",
    fill: "#c7cbd1"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1516",
    width: 7,
    height: 4,
    rx: 1,
    transform: "rotate(90 -1 107.5)",
    fill: "#ffc1c8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1517",
    width: 7,
    height: 4,
    rx: 1,
    transform: "rotate(90 11.852 120.352)",
    fill: "#fe8392"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1519",
    width: 7,
    height: 4,
    rx: 1,
    transform: "rotate(90 24.704 133.204)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1515",
    width: 8,
    height: 4,
    rx: 1,
    transform: "translate(108 117)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1521",
    width: 8,
    height: 4,
    rx: 1,
    transform: "translate(134 117)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1522",
    width: 8,
    height: 4,
    rx: 1,
    transform: "translate(160 117)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1508",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(92 89)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#eaeaea",
    d: "M20 24h220v16H20z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1228",
    transform: "translate(-669 -2205)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1512",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(870 2265)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1514",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(872 2274)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1513",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(867 2270)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 29,
    transform: "translate(49 69)",
    fill: "#454545",
    fontSize: 12,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "29")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfiler);
export default __webpack_public_path__ + "static/media/risk-profiler.78a13f6e44de4cda5e473b2372e7e879.svg";
export { ForwardRef as ReactComponent };